
  <div class="flex  justify-center h-auto mb-4 bg-white p-4">
    <div>
      <!-- Título -->
      <h2 class="headline-07 text-2xl font-bold text-[#134F82] mt-4 mb-2">
        Nos gustaría escucharte
      </h2>

      <!-- Subtítulo -->
      <div class="mb-4">
        <p class="text-sm text-gray-600 paragraph-default">
          Ingresa los datos solitados, para poder ayudarte.
        </p>
      </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-2">
     
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" type="text" />
            <mat-error *ngIf="form.get('nombre')?.hasError('required')">Campo requerido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Correo electrónico</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-error *ngIf="form.get('email')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')">Correo inválido</mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Teléfono</mat-label>
            <input matInput formControlName="telefono" type="tel" />
            <mat-error *ngIf="form.get('telefono')?.hasError('telefono')">Campo requerido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Déjanos conocer tu opinión</mat-label>
            <textarea matInput formControlName="opinion"></textarea>
            <mat-error *ngIf="form.get('opinion')?.hasError('opinion')">Campo requerido</mat-error>
        </mat-form-field>

      <button color="primary" class="w-full rounded-full bg-[#0E365A] text-white py-3 hover:bg-[#0c2f4e]" type="submit"
        [disabled]="form.invalid">
        Enviar
      </button>
      
    </form>
    </div>
  </div>
